import { Snackbar } from "@mui/material"; 
import MuiAlert from "@mui/lab/Alert";
import { Component, RefObject } from "react";
import { FOXORDER_V2 } from "../../controller/constant/ActionConstant";
import DialogEstablishmentComponent from "../Authentication/DialogEstablishmentComponent";
import LoadingComponent from "../utils/LoadingComponent";
import LoginForm from "../utils/login-form/LoginForm";
import { Shop } from "../../controller/api/FoxOrderApi";
import { WithStylesProps } from "../utils/WithStyles";

interface FoxOrderLoginStateInterface extends WithStylesProps {
    showError: boolean
    message: string | undefined
    shops: Shop[]
    _handleCloseSnackBar: () => void
    _handleTapLoginButton: () => void
    isLoading: boolean
    usernameRef: RefObject<HTMLInputElement>
    passwordRef: RefObject<HTMLInputElement>
    showEstablishments: boolean
    _handleShowEstablishments: (establishment: Shop) => void
}

class FoxorderLogin extends Component<FoxOrderLoginStateInterface> {

    render() {
        const { showError, _handleCloseSnackBar, _handleTapLoginButton, message, isLoading, usernameRef, passwordRef, showEstablishments, _handleShowEstablishments } = this.props;
        return (
            <div style={this.props.styles.rootStyle}>
                {
                    isLoading && <LoadingComponent isOpen={isLoading} />
                }
                <DialogEstablishmentComponent
                    establishments={this.props.shops}
                    handleSelectEstablishment={_handleShowEstablishments}
                    isOpen={showEstablishments}
                />
                <Snackbar
                    open={showError}
                    autoHideDuration={6000}
                    onClose={_handleCloseSnackBar}
                >
                    <MuiAlert severity="error" onClose={_handleCloseSnackBar}>
                        {message}
                    </MuiAlert>
                </Snackbar>
                <h1>{FOXORDER_V2} Login</h1>
                <div style={this.props.styles.formStyle}>
                    <LoginForm>
                        <LoginForm.Input name="login" placeholder="Username" type="text" inputRef={usernameRef} styles={{ color: this.props.styles.color, fontSize: this.props.styles.fontSize }} />
                        <LoginForm.Input name="password" placeholder="Password" type="password" inputRef={passwordRef} styles={{ color: this.props.styles.color, fontSize: this.props.styles.fontSize }} />
                        <div style={this.props.styles.formButtonStyle}>
                            <LoginForm.Submit onSubmit={_handleTapLoginButton}
                            >
                                Connexion
                            </LoginForm.Submit>
                        </div>
                    </LoginForm>
                </div>
            </div>
        );
    }
}

export default FoxorderLogin